import request from '@/utils/request'

// 查询联盟推广订单关联分页
export function pageUnionPromotionOrder(query) {
  return request({
    url: '/union/union/promotion/order/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}
